import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const offer = useConnect('offer.byId', {
    id: Number(match.params.offerId)
  });

  if (offer.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      offer={offer}
      page="Description"
      title="What are you offering?"
      description={(
        <>
          Tell the educator what students will be doing and what structure, materials, or
          other support you're ready to provide as part of your Offer.
        </>
      )}
    >
      <Form
        user={user}
        offer={offer}
        navigation={(
          <Navigation v5={true} activeStep={1} steps={16}/>
        )}
        onPrevious={(newData) => history.push(Urls(offer).ACTIVITY)}
        onNext={(newData) => history.push(Urls(offer).AUDIENCE)}
        onSkip={() => history.push(Urls(offer).AUDIENCE)}
        onExit={() => history.push(Urls(offer).OFFER_EDIT)}
      />
    </ParentLayout>
  );
};
